import MuiModal, {ModalProps as MuiModalProps} from '@mui/material/Modal'

import './styles.scss'

export const Modal: React.FC<MuiModalProps> = ({
  children,
  classes,
  ...rest
}) => {
  return (
    <MuiModal
      classes={{root: 'override-menu-root', backdrop: 'override-backdrop', ...classes}}
      {...rest}
    >
      {children}
    </MuiModal>
  )
}
